<template>
  <GenericError>
    <template #hat>
      <p class="text-h1">
        Une erreur est survenue, vous n’avez rien à faire, le service numérique en charge a été prévenu.
      </p>
      <p class="text-h1 mt-1">L'équipe Parapheur.</p>
    </template>

    <template #help> Si vous avez besoin d'une aide immédiate, merci de nous contacter </template>

    <template #btn-home>
      <PButton to="/" class="mr-2">Page d'accueil</PButton>
    </template>

    <template #btn-contact>
      <PButton :to="`mailto:${conf.contact}`" mode="secondary"> Contactez-nous </PButton>
    </template>
  </GenericError>
</template>

<script setup lang="ts">
import { GenericError, type PastaConfig, PButton, useConfig } from "@pasta/box-v2";

const conf = useConfig<PastaConfig>();
</script>
